import { ChangeEvent, FC, MouseEvent } from 'react'

type UploadFileProps = {
  file: File
  objectUrl: string
}

type InputFileProps = {
  handleUpload: (props: UploadFileProps[]) => void
  accept?: string
  disabled?: boolean
  multiple?: boolean
}

const InputFile: FC<InputFileProps> = ({
  accept = '*',
  multiple,
  handleUpload,
  disabled,
}) => {
  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    if (!target.files) return

    const props = Array.from(target.files).map((file) => ({
      file,
      objectUrl: URL.createObjectURL(file),
    }))

    handleUpload(props)
    target.value = ''
  }

  const handleClick = (event: MouseEvent<HTMLInputElement>) => {
    event.stopPropagation()

    if (disabled) event.preventDefault()
  }

  return (
    <div className="hidden">
      <input
        type="file"
        data-button="input file"
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
        onClick={handleClick}
      />
    </div>
  )
}

export { InputFile, type UploadFileProps }
